export const FLAG_SHOP_ONLINE_VIDEOS = "shop-online-videos";
export const FLAG_IS_ZITADEL_SSO_MICROSOFT_ENABLED = "zitadel.sso.method.is-microsoft-enabled";
export const FLAG_IS_ZITADEL_SSO_GOOGLE_ENABLED = "zitadel.sso.method.is-google-enabled";
